export default __webpack_public_path__ + "static/media/rocket_anim_130.67436bc5.png";